import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  filtersBar: {
    marginBottom: 20,
    padding: '10px 15px',
  },
  label: {
    marginRight: 10,
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
  },
}));
